/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const CTAContainer = styled.div`
  .data-layer-form {
    justify-content: ${(props) =>
      props.fullWidth ? 'center !important' : 'flex-start !important'};
  }

  @media (max-width: 767px) {
    .hero-contextual-cta--origin {
      margin-top: 40px;
    }
  }
`;
